/* eslint-disable class-methods-use-this */
import ReduceStore from "flux/lib/FluxReduceStore";

import ProjectActivity from "../../../foundation/api/model/barrels/ProjectActivity";
import ProjectActivityType from "../../../foundation/api/model/barrels/ProjectActivityType";
import * as ScreenActionPayloads from "../screen/ScreenActionPayloads";
import ScreenActionTypes from "../screen/ScreenActionTypes";
import { AllPayloads } from "../payloads";

import * as Payloads from "./ProjectActivitiesActionPayloads";
import ProjectActivitiesActionTypes from "./ProjectActivitiesActionTypes";

interface State {
    activities: ProjectActivity[] | null;
    nextCursorId: string | undefined;
}

class ProjectActivitiesStore extends ReduceStore<State, AllPayloads> {
    getInitialState(): State {
        return {
            activities: null,
            nextCursorId: undefined
        };
    }

    reset(): State {
        return {
            ...this.getInitialState()
        };
    }

    setProjectActivities(state: State, {
        activities,
        nextCursorId
    }: Payloads.SetProjectActivities): State {
        return {
            ...state,
            activities,
            nextCursorId
        };
    }

    updateProjectActivities(state: State, {
        activities,
        nextCursorId
    }: Payloads.UpdateProjectActivities): State {
        if (!state.activities) {
            return state;
        }

        const newActivityIds = new Set(activities.map(activity => activity._id));

        const oldActivities = state.activities.filter(activity =>
            !activity.incomplete && !newActivityIds.has(activity._id)
        );

        return {
            ...state,
            activities: [...activities, ...oldActivities],
            nextCursorId
        };
    }

    removeDotMentionActivities(state: State, {
        did
    }: ScreenActionPayloads.RemoveDot): State {
        if (!state.activities) {
            return state;
        }

        return {
            ...state,
            activities: state.activities.filter(activity =>
                activity.type !== ProjectActivityType.UserCreateScreenCommentMention ||
                activity.events[0].dot._id !== did
            )
        };
    }

    removeCommentMentionActivities(state: State, {
        did,
        cmid
    }: Pick<ScreenActionPayloads.RemoveComment, "did" | "cmid">): State {
        if (!state.activities) {
            return state;
        }

        return {
            ...state,
            activities: state.activities.filter(activity =>
                activity.type !== ProjectActivityType.UserCreateScreenCommentMention ||
                activity.events[0].dot._id !== did ||
                activity.events[0].dot.comment._id !== cmid
            )
        };
    }

    // eslint-disable-next-line complexity
    reduce(state: State, action: AllPayloads): State {
        switch (action.type) {
            case ProjectActivitiesActionTypes.SET_PROJECT_ACTIVITIES:
                return this.setProjectActivities(state, action);

            case ProjectActivitiesActionTypes.UPDATE_PROJECT_ACTIVITIES:
                return this.updateProjectActivities(state, action);

            case ScreenActionTypes.REMOVE_DOT:
                return this.removeDotMentionActivities(state, action);

            case ScreenActionTypes.REMOVE_COMMENT:
                return this.removeCommentMentionActivities(state, action);

            default:
                return state;
        }
    }
}

export default ProjectActivitiesStore;
export {
    State as ProjectActivitiesStoreState
};
